<template>
  <div class="footer">
    <div class="container">
      <div class="footer_content">
        <div class="footer_content-info">
          <div class="footer_content-info-txt">
            <span class="footer_content-info-txt-span">Телефон:</span>
            <h4 class="footer_content-info-txt-contacts">
              <a
                href="tel:+998946453636"
                class="footer_content-info-txt-contacts-number"
                onclick="gtag('event', 'click', {'event_category': 'number'}); return true;"
                >94 645 36 36</a
              >
            </h4>
          </div>
          <div class="footer_content-info-txt">
            <span class="footer_content-info-txt-span">E-mail:</span>
            <h4 class="footer_content-info-txt-contacts">
              <a
                class="footer_content-info-txt-contacts-add"
                href="mailto:info@centris.uz"
                >info@centris.uz</a
              >
            </h4>
          </div>
          <div class="footer_content-info-txt">
            <span class="footer_content-info-txt-span">Адрес:</span>
            <div class="footer_content-info-txt-contacts">
              <a
                class="footer_content-info-txt-contacts-add"
                href="https://yandex.com/maps/-/CDunyM7L"
                target="blank"
                rel="noopener"
                >Ташкент, Мирабадский район, ул. Кушкуприк 28/1-дом</a
              >
            </div>
          </div>
          <div class="footer_content-info-txt">
            <span class="footer_content-info-txt-span">График работы:</span>
            <h4 class="footer_content-info-txt-contacts">
              Пн.-Пт.: 09:00 - 18:00
            </h4>
          </div>
        </div>
        <div class="footer_content-form">
          <form
            id="reg-course"
            class="modal__form"
            @submit.prevent
            @submit="sendFormData"
          >
            <input
              type="text"
              placeholder="Ваше имя*"
              name="modal-name"
              class="form__input crm-form__input"
              required
              autocomplete="off"
              v-model="modalName"
            />
            <input
              type="tel"
              placeholder="Номер телефона*"
              name="modal-tel"
              class="form__input crm-form__input hidden__phone"
              maxlength="17"
              v-model="modalPhone"
              @input="inputNumber"
              @focus="focusNumber"
              @blur="blurNumber"
              required
            />
            <FooterFormDropDown
              @selectRow="selectServiceRow"
              :submitted="submitted"
            ></FooterFormDropDown>
            <input
              type="text"
              placeholder="Telegram @username"
              name="modal-name"
              class="form__input crm-form__input hidden__phone"
              v-model="modalUserName"
            />
            <button
              class="modal-btn"
              v-if="!submitted"
              onclick="gtag('event', 'click', {'event_category': 'form'}); return true;"
            >
              Оставить заявку
            </button>
            <button class="modal-btn-accept" v-if="submitted">
              ВАША ЗАЯВКА ПРИНЯТА ✔
            </button>
          </form>
          <p class="footer_content-form-descr">
            Оставьте заявку и наши менеджера свяжутся с вами в ближайшее время
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterFormDropDown from "./footerFormDropDown.vue";

export default {
  data() {
    return {
      submitted: false,
      modalName: "",
      modalPhone: "",
      modalUserName: "",
      modalSelectService: "Какая услуга вас интересует ?*",
    };
  },
  watch: {},
  methods: {
    sendFormData() {
      if (
        this.modalName != "" &&
        this.modalPhone != "" &&
        this.modalSelectService != "Какая услуга вас интересует ?*" &&
        this.modalPhone.length == 17
      ) {
        const formData = new FormData();
        formData.append("name", this.modalName);
        formData.append("username", this.modalUserName);
        formData.append("contact", this.modalPhone);
        formData.append("service", this.modalSelectService);

        this.submitted = true;
        this.$store.dispatch("sendForm", formData).then((response) => {
          this.modalName = "";
          this.modalPhone = "";
          this.modalUserName = "";
          this.modalSelectService = "Какая услуга вас интересует ?*";
          this.submitted = true;
          setTimeout(() => {
            this.submitted = false;
            this.$emit("close");
          }, 3000);
        });
      }
    },
    inputNumber(event) {
      if (this.modalPhone.length < 5) this.modalPhone = "+998 ";
      this.modalPhone = this.modalPhone.replace(/[^+|^\d|^\s]/, "");
      const lengths = [4, 7, 11, 14];
      lengths.forEach((item) => {
        if (this.modalPhone.length == item && event.data) {
          this.modalPhone += " ";
        }
      });
    },
    focusNumber() {
      if (this.modalPhone == "") this.modalPhone = "+998 ";
    },
    blurNumber() {
      if (this.modalPhone == "+998 ") this.modalPhone = "";
    },
    closeModal() {
      this.$emit("close");
    },
    selectServiceRow(text) {
      this.modalSelectService = text;
    },
  },
  components: { FooterFormDropDown },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";
.footer {
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;
  background: rgba(167, 167, 167, 0.06);
  backdrop-filter: blur(15px);
  @include adaptivPaddinglg(0, 0, 120, 120, 0, 0, 80, 80);
  position: relative;
  @media (max-width: 768px) {
    @include adaptivPaddingmd(0, 0, 80, 175, 0, 0, 50, 75);
  }
  &_content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
    }
    &-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-bottom: 50px;
      &-txt {
        width: 80%;
        @include adaptivMarginlg(0, 0, 0, 10, 0, 0, 0, 5);
        @media (min-width: 1921px) {
          margin: 0;
        }
        @media (max-width: 768px) {
          @include adaptivMarginmd(0, 0, 20, 30, 0, 0, 10, 20);
          width: 100%;
        }
        &:last-of-type {
          margin-top: 0;
        }
        &:first-of-type {
          @include adaptivMarginlg(0, 0, 31, 0, 0, 0, 22, 0);
          @media (max-width: 768px) {
            @include adaptivMarginmd(0, 0, 20, 30, 0, 0, 10, 20);
          }
        }
        &-span {
          font-family: "Helvetica-normal";
          @include adaptiv-fontlg(15, 15);
          @include adaptiv-lineHeightlg(18, 18);
          color: #8e8e8e;
          @media (max-width: 768px) {
            @include adaptiv-fontmd(25, 14);
            @include adaptiv-lineHeightmd(28, 14);
            @include adaptivMarginmd(0, 0, 0, 5, 0, 0, 0, 3);
          }
          @media (min-width: 1921px) {
            font-size: 20px;
          }
        }
        &-contacts {
          font-family: "Helvetica-normal";
          @include adaptiv-fontlg(22, 18);
          @include adaptiv-lineHeightlg(25, 21);
          color: #fff;
          @include adaptivMarginlg(0, 0, 6, 15, 0, 0, 4, 8);
          @media (max-width: 768px) {
            @include adaptiv-fontmd(30, 16);
            @include adaptiv-lineHeightmd(36, 19);
          }
          &-add,
          &-number {
            color: #fff;
            transition: 0.5s;
            &:hover {
              color: #7338d8;
              transition: 0.5s;
            }
          }
          &-number {
            font-family: "Helvetica-bold";
          }
        }
      }
    }
    &-form {
      @include adaptivWidthLg(444, 320);
      width: 100%;
      justify-content: center;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      @media (max-width: 768px) {
        width: 100%;
        @include adaptivWidthmd(550, 250);
      }
      .modal-btn,
      .modal-btn-accept {
        position: relative;
        overflow: hidden;

        display: flex;
        align-items: center;
        justify-content: center;
        @include adaptivWidthLg(444, 320);
        width: 100%;
        @include adaptivHeightlg(49, 35);
        background: #2b2a29;
        color: #fff;
        @include adaptiv-fontlg(15, 15);
        @include adaptiv-lineHeightlg(15, 15);
        font-family: "Helvetica-normal";
        margin: 0 auto;
        transition: 0.5s;
        .button-link {
          color: #303030;
        }
        &-accept {
          background: #7338d8;
          @include adaptiv-fontlg(15, 12);
        }
        &::after {
          content: "";
          display: block;
          width: 30px;
          height: 250px;
          margin-left: 50px;
          background: #fff;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0.2) 100%
          );

          backdrop-filter: blur(5px);
          left: -40px;
          top: -80px;
          z-index: 1;
          transform: rotate(45deg);
          position: absolute;
          animation: movingFlare 4s ease-in-out 0s infinite;
        }

        @keyframes movingFlare {
          0% {
            left: -90px;
            margin-left: 0px;
          }
          30% {
            left: 110%;
            margin-left: 80px;
          }
          100% {
            left: 110%;
            margin-left: 80px;
          }
        }
        @media (max-width: 768px) {
          @include adaptivWidthmd(550, 250);
          @include adaptivHeightmd(96, 40);
          @include adaptiv-fontmd(35, 14);
          @include adaptiv-lineHeightlg(35, 14);
          .modal-btn-accept {
            @media (max-width: 768px) {
              @include adaptivWidthmd(550, 250);
              @include adaptivHeightmd(96, 40);
              @include adaptiv-fontmd(25, 12);
              @include adaptiv-lineHeightlg(25, 12);
            }
          }
        }
        // @media (min-width: 1921px) {
        //   font-size: 20px;
        //   height: 60px;
        // }
        &:hover {
          background: #7338d8;
          transition: 0.5s;
        }
      }
      .form__input {
        width: 100%;
        @include adaptivHeightlg(49, 35);
        display: block;
        font-family: "Helvetica-normal";
        font-style: normal;
        font-weight: 300;
        color: #aaaaaa;
        @include adaptiv-fontlg(15, 12);
        @include adaptiv-lineHeightlg(18, 15);
        @include adaptivMarginlg(0, 0, 0, 12, 0, 0, 0, 6);
        @include adaptivPaddinglg(25, 25, 0, 0, 10, 10, 0, 0);
        border: none;
        background: #eeeded;
        border-radius: 0px;
        @media (min-width: 1921px) {
          font-size: 17px;
          height: 45px;
        }
        @media (max-width: 768px) {
          @include adaptivMarginmd(0, 0, 27, 27, 0, 0, 12, 12);
          @include adaptiv-fontmd(31, 12);
          @include adaptiv-lineHeightmd(31, 12);
          @include adaptivHeightmd(96, 30);
          @include adaptivPaddingmd(15, 15, 0, 0, 10, 10, 0, 0);
        }
      }
      &-descr {
        font-family: "Helvetica-normal";
        font-weight: 400;
        @include adaptiv-fontlg(18, 14);
        @include adaptiv-lineHeightlg(20, 16);
        color: #fff;
        text-align: center;
        @include adaptivMarginlg(0, 0, 30, 0, 0, 0, 15, 0);
        @media (max-width: 768px) {
          @include adaptiv-fontmd(25, 12);
          @include adaptiv-lineHeightmd(28, 12);
          @include adaptivMarginmd(0, 0, 40, 0, 0, 0, 20, 0);
        }
      }
    }
  }
}
</style>
